/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";


class home extends React.Component {
  render() {
    return (
      
      <div data-bs-spy="scroll" data-bs-target=".navbar" data-bs-offset="51">
        <nav
          class="navbar navbar-expand-lg bg-white navbar-light fixed-top shadow py-lg-0 px-4 px-lg-5 wow fadeIn"
          data-wow-delay="0.1s">
          <a href="index.html" class="navbar-brand d-block d-lg-none">
            <h1 class="text-primary fw-bold m-0">Homie</h1>
          </a>
          <button
            type="button"
            class="navbar-toggler"
            data-bs-toggle="collapse"
            data-bs-target="#navbarCollapse"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
          <div
            class="collapse navbar-collapse justify-content-between py-4 py-lg-0"
            id="navbarCollapse"
          >
            <div class="navbar-nav ms-auto py-0">
              <a href="#home" class="nav-item nav-link active">
                Home
              </a>
              <a href="#about" class="nav-item nav-link">
                About
              </a>
              <a href="#skill" class="nav-item nav-link">
                Skills
              </a>
              <a href="#service" class="nav-item nav-link">
                Services
              </a>
            </div>
            <a
              href="index.html"
              class="navbar-brand bg-secondary py-3 px-4 mx-3 d-none d-lg-block"
            >
              <h1 class="text-primary fw-bold m-0">Homie</h1>
            </a>
            <div class="navbar-nav me-auto py-0">
              <a href="#project" class="nav-item nav-link">
                Projects
              </a>
              <a href="#team" class="nav-item nav-link">
                Team
              </a>
              <a href="#testimonial" class="nav-item nav-link">
                Testimonial
              </a>
              <a href="#contact" class="nav-item nav-link">
                Contact
              </a>
            </div>
          </div>
        </nav>

        <div class="container-fluid bg-light my-6 mt-0" id="home">
        <div class="container">
            <div class="row g-5 align-items-center">
                <div class="col-lg-6 py-6 pb-0 pt-lg-0">
                    <h3 class="text-primary mb-3">I'm</h3>
                    <h1 class="display-3 mb-3">Samuel Amoah</h1>
                    <h2 class="typed-text-output d-inline">Web Designer</h2>
                    <div class="typed-text d-none">Web Designer, Web Developer, Front End Developer, Apps Designer, Apps Developer</div>
                    <div class="d-flex align-items-center pt-5">
                        <a href="./img/luxurybrandgh_qr.png" download="" class="btn btn-primary py-3 px-4 me-5">Download CV</a>
                        <button type="button" class="btn-play" data-bs-toggle="modal"
                      
                            data-src="https://www.youtube.com/embed/fxZ4H-gq_lc" data-bs-target="#videoModal">
                            
                            <span></span>
                        </button>
                        <h5 class="ms-4 mb-0 d-none d-sm-block">Play Video</h5>
                    </div>
                </div>
                <div class="col-lg-6">
                    <img class="img-fluid" src="./assets/img/profile.png" alt=""/>
                </div>
            </div>
        </div>
        </div>

        <div
          class="modal modal-video fade"
          id="videoModal"
          tabindex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog">
            <div class="modal-content rounded-0">
              <div class="modal-header">
                <h3 class="modal-title" id="exampleModalLabel">
                  Youtube Video
                </h3>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                <div class="ratio ratio-16x9">
                  <iframe
                    class="embed-responsive-item"
                    src=""
                    id="video"
                    allowfullscreen
                    allowscriptaccess="always"
                    allow="autoplay"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="container-xxl py-6" id="about">
          <div class="container">
            <div class="row g-5">
              <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
                <div class="d-flex align-items-center mb-5">
                  <div class="years flex-shrink-0 text-center me-4">
                    <h1 class="display-1 mb-0">2</h1>
                    <h5 class="mb-0">Years</h5>
                  </div>
                  <h3 class="lh-base mb-0">
                    of working experience as a web designer & developer
                  </h3>
                </div>
                <p class="mb-4">
                  I am a UX, UI and front end specialist from Ghana. What
                  started off 5 years ago as an adventure through wireframes and
                  layouts, has turned into passion for front end development and
                  graphic design. Honing these skills has allowed my UX and UI
                  roots to grow deeper into everything I do, making it all come
                  together.
                </p>
                <p class="mb-3">
                  <i class="far fa-check-circle text-primary me-3"></i>High End
                  Designs
                </p>
                <p class="mb-3">
                  <i class="far fa-check-circle text-primary me-3"></i>High
                  Quality Product
                </p>
                <p class="mb-3">
                  <i class="far fa-check-circle text-primary me-3"></i>On Time
                  Project Delivery
                </p>
                <a class="btn btn-primary py-3 px-5 mt-3" href="">
                  Read More
                </a>
              </div>
              <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
                <div class="row g-3 mb-4">
                  <div class="col-sm-6">
                    <img
                      class="img-fluid rounded"
                      src="assets/img/about-1.jpg"
                      alt=""
                    />
                  </div>
                  <div class="col-sm-6">
                    <img
                      class="img-fluid rounded"
                      src="assets/img/about-2.jpg"
                      alt=""
                    />
                  </div>
                </div>
                <div class="d-flex align-items-center mb-3">
                  <h5 class="border-end pe-3 me-3 mb-0">Happy Clients</h5>
                  <h2
                    class="text-primary fw-bold mb-0"
                    data-toggle="counter-up"
                  >
                    1234
                  </h2>
                </div>
                <p class="mb-4">
                  The first time I got asked to speak at a conference, my gut
                  reaction was “heck no. That sounds terrifying”. So naturally I
                  said yes. Since then I’ve spoken at conferences and meet-ups
                  all over the world. It still terrifies me.
                </p>
                <div class="d-flex align-items-center mb-3">
                  <h5 class="border-end pe-3 me-3 mb-0">Projects Completed</h5>
                  <h2
                    class="text-primary fw-bold mb-0"
                    data-toggle="counter-up"
                  >
                    1234
                  </h2>
                </div>
                <p class="mb-0">
                  Currently I'm a freelance designer and web developer, who
                  works with a variety of clients and on many diverse projects.
                  I work to create innovative solutions that inspire, and foster
                  memorable relationships between brands and their clients. With
                  a focus on branding and UI / Web, I strive to create usable
                  and polished products through passionate and deliberate
                  design.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="container-xxl py-6 pb-5" id="skill">
          <div class="container">
            <div class="row g-5">
              <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
                <h1 class="display-5 mb-5">Skills & Experience</h1>
                <p class="mb-4">
                  Since beginning my journey as a freelance developer nearly 2
                  years ago, I’ve done remote work for agencies, consulted for
                  startups, and collaborated with talented people to create web
                  products for both business and consumer use. I create
                  successful responsive websites that are fast, easy to use, and
                  built with best practices. The main area of my expertise is
                  front-end development, HTML, CSS, JS, building small and
                  medium web apps, custom plugins, features, animations, and
                  coding interactive layouts. I also have full-stack developer
                  experience with popular open-source CMS like (WordPress,
                  Drupal, Magento, Keystone.js and others) .
                </p>
                <h3 class="mb-4">My Skills</h3>
                <div class="row align-items-center">
                  <div class="col-md-6">
                    <div class="skill mb-4">
                      <div class="d-flex justify-content-between">
                        <h6 class="font-weight-bold">HTML</h6>
                        <h6 class="font-weight-bold">95%</h6>
                      </div>
                      <div class="progress">
                        <div
                          class="progress-bar bg-primary"
                          role="progressbar"
                          aria-valuenow="95"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                    </div>
                    <div class="skill mb-4">
                      <div class="d-flex justify-content-between">
                        <h6 class="font-weight-bold">CSS</h6>
                        <h6 class="font-weight-bold">85%</h6>
                      </div>
                      <div class="progress">
                        <div
                          class="progress-bar bg-warning"
                          role="progressbar"
                          aria-valuenow="85"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                    </div>
                    <div class="skill mb-4">
                      <div class="d-flex justify-content-between">
                        <h6 class="font-weight-bold">Photoshop</h6>
                        <h6 class="font-weight-bold">90%</h6>
                      </div>
                      <div class="progress">
                        <div
                          class="progress-bar bg-danger"
                          role="progressbar"
                          aria-valuenow="90"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="skill mb-4">
                      <div class="d-flex justify-content-between">
                        <h6 class="font-weight-bold">Javascript</h6>
                        <h6 class="font-weight-bold">90%</h6>
                      </div>
                      <div class="progress">
                        <div
                          class="progress-bar bg-danger"
                          role="progressbar"
                          aria-valuenow="90"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                    </div>
                    <div class="skill mb-4">
                      <div class="d-flex justify-content-between">
                        <h6 class="font-weight-bold">React</h6>
                        <h6 class="font-weight-bold">95%</h6>
                      </div>
                      <div class="progress">
                        <div
                          class="progress-bar bg-dark"
                          role="progressbar"
                          aria-valuenow="95"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                    </div>
                    <div class="skill mb-4">
                      <div class="d-flex justify-content-between">
                        <h6 class="font-weight-bold">Wordpress</h6>
                        <h6 class="font-weight-bold">85%</h6>
                      </div>
                      <div class="progress">
                        <div
                          class="progress-bar bg-info"
                          role="progressbar"
                          aria-valuenow="85"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
                <ul class="nav nav-pills rounded border border-2 border-primary mb-5">
                  <li class="nav-item w-50">
                    <button
                      class="nav-link w-100 py-3 fs-5 active"
                      data-bs-toggle="pill"
                      href="#tab-1"
                    >
                      Experience
                    </button>
                  </li>
                  <li class="nav-item w-50">
                    <button
                      class="nav-link w-100 py-3 fs-5"
                      data-bs-toggle="pill"
                      href="#tab-2"
                    >
                      Education
                    </button>
                  </li>
                </ul>
                <div class="tab-content">
                  <div id="tab-1" class="tab-pane fade show p-0 active">
                    <div class="row gy-5 gx-4">
                      <div class="col-sm-6">
                        <h5>UI Designer</h5>
                        <hr class="text-primary my-2" />
                        <p class="text-primary mb-1">2013 - 2022</p>
                        <h6 class="mb-0">Apex Software Inc</h6>
                      </div>
                      <div class="col-sm-6">
                        <h5>Product Designer</h5>
                        <hr class="text-primary my-2" />
                        <p class="text-primary mb-1">2018 - 2045</p>
                        <h6 class="mb-0">Apex Software Inc</h6>
                      </div>
                      <div class="col-sm-6">
                        <h5>Web Designer</h5>
                        <hr class="text-primary my-2" />
                        <p class="text-primary mb-1">2016 - 2021</p>
                        <h6 class="mb-0">Apex Software Inc</h6>
                      </div>
                      <div class="col-sm-6">
                        <h5>Apps Designer</h5>
                        <hr class="text-primary my-2" />
                        <p class="text-primary mb-1">2016 - 2019</p>
                        <h6 class="mb-0">Apex Software Inc</h6>
                      </div>
                    </div>
                  </div>
                  <div id="tab-2" class="tab-pane fade show p-0">
                    <div class="row gy-5 gx-4">
                      <div class="col-sm-6">
                        <h5>UI Design Course</h5>
                        <hr class="text-primary my-2" />
                        <p class="text-primary mb-1">2011 - 2019</p>
                        <h6 class="mb-0">Kumasi Technical University</h6>
                      </div>
                      <div class="col-sm-6">
                        <h5>IOS Development</h5>
                        <hr class="text-primary my-2" />
                        <p class="text-primary mb-1">2015 - 2018</p>
                        <h6 class="mb-0">Kumasi Technical University</h6>
                      </div>
                      <div class="col-sm-6">
                        <h5>Web Design</h5>
                        <hr class="text-primary my-2" />
                        <p class="text-primary mb-1">2016 - 2020</p>
                        <h6 class="mb-0">Kumasi Technical University</h6>
                      </div>
                      <div class="col-sm-6">
                        <h5>Apps Design</h5>
                        <hr class="text-primary my-2" />
                        <p class="text-primary mb-1">2012 - 2017</p>
                        <h6 class="mb-0">Kumasi Technical University</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="container-fluid bg-light my-5 py-6" id="service">
          <div class="container">
            <div class="row g-5 mb-5 wow fadeInUp" data-wow-delay="0.1s">
              <div class="col-lg-6">
                <h1 class="display-5 mb-0">My Services</h1>
              </div>
              <div class="col-lg-6 text-lg-end">
                <a class="btn btn-primary py-3 px-5" href="">
                  Hire Me
                </a>
              </div>
            </div>
            <div class="row g-4">
              <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
                <div class="service-item d-flex flex-column flex-sm-row bg-white rounded h-100 p-4 p-lg-5">
                  <div class="bg-icon flex-shrink-0 mb-3">
                    <i class="fa fa-crop-alt fa-2x text-dark"></i>
                  </div>
                  <div class="ms-sm-4">
                    <h4 class="mb-3">Creative Design</h4>
                    <h6 class="mb-3">
                      Start from <span class="text-primary">GH₵1999</span>
                    </h6>
                    <span>
                      Web design and development have been my bread and butter
                      for more than 5 years. During that time I've discovered
                      that I can help startups and companies with the following
                      services.
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
                <div class="service-item d-flex flex-column flex-sm-row bg-white rounded h-100 p-4 p-lg-5">
                  <div class="bg-icon flex-shrink-0 mb-3">
                    <i class="fa fa-code-branch fa-2x text-dark"></i>
                  </div>
                  <div class="ms-sm-4">
                    <h4 class="mb-3">Graphic Design</h4>
                    <h6 class="mb-3">
                      Start from <span class="text-primary">GH₵1999</span>
                    </h6>
                    <span>
                      Successful online projects start with good design. It
                      establishes a solid foundation for future development and
                      allows for long term growth.
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
                <div class="service-item d-flex flex-column flex-sm-row bg-white rounded h-100 p-4 p-lg-5">
                  <div class="bg-icon flex-shrink-0 mb-3">
                    <i class="fa fa-code fa-2x text-dark"></i>
                  </div>
                  <div class="ms-sm-4">
                    <h4 class="mb-3">Web Design</h4>
                    <h6 class="mb-3">
                      Start from <span class="text-primary">GH₵1999</span>
                    </h6>
                    <span>
                      I can code my own designs or even use the customer's
                      design as base. My focus is to generate clean code that's
                      well structured for reliability.
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
                <div class="service-item d-flex flex-column flex-sm-row bg-white rounded h-100 p-4 p-lg-5">
                  <div class="bg-icon flex-shrink-0 mb-3">
                    <i class="fa fa-laptop-code fa-2x text-dark"></i>
                  </div>
                  <div class="ms-sm-4">
                    <h4 class="mb-3">UI/UX Design</h4>
                    <h6 class="mb-3">
                      Start from <span class="text-primary">GH₵1999</span>
                    </h6>
                    <span>
                      i can setup your project to use basic SEO principles which
                      will push your project to the first page on search engines
                      and save you ads money
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="container-xxl py-6 pt-5" id="project">
          <div class="container">
            <div
              class="row g-5 mb-5 align-items-center wow fadeInUp"
              data-wow-delay="0.1s"
            >
              <div class="col-lg-6">
                <h1 class="display-5 mb-0">My Projects</h1>
              </div>
              <div class="col-lg-6 text-lg-end">
                <ul class="list-inline mx-n3 mb-0" id="portfolio-flters">
                  <li class="mx-3 active" data-filter="*">
                    All Projects
                  </li>
                  <li class="mx-3" data-filter=".first">
                    UI/UX Design
                  </li>
                  <li class="mx-3" data-filter=".second">
                    Graphic Design
                  </li>
                </ul>
              </div>
            </div>
            <div
              class="row g-4 portfolio-container wow fadeInUp"
              data-wow-delay="0.1s"
            >
              <div class="col-lg-4 col-md-6 portfolio-item first">
                <div class="portfolio-img rounded overflow-hidden">
                  <img
                    class="img-fluid"
                    src="assets/img/project-1.jpg"
                    alt=""
                  />
                  <div class="portfolio-btn">
                    <a
                      class="btn btn-lg-square btn-outline-secondary border-2 mx-1"
                      href="assets/img/project-1.jpg"
                      data-lightbox="portfolio"
                    >
                      <i class="fa fa-eye"></i>
                    </a>
                    <a
                      class="btn btn-lg-square btn-outline-secondary border-2 mx-1"
                      href=""
                    >
                      <i class="fa fa-link"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 portfolio-item second">
                <div class="portfolio-img rounded overflow-hidden">
                  <img
                    class="img-fluid"
                    src="assets/img/project-2.jpg"
                    alt=""
                  />
                  <div class="portfolio-btn">
                    <a
                      class="btn btn-lg-square btn-outline-secondary border-2 mx-1"
                      href="assets/img/project-2.jpg"
                      data-lightbox="portfolio"
                    >
                      <i class="fa fa-eye"></i>
                    </a>
                    <a
                      class="btn btn-lg-square btn-outline-secondary border-2 mx-1"
                      href=""
                    >
                      <i class="fa fa-link"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 portfolio-item first">
                <div class="portfolio-img rounded overflow-hidden">
                  <img
                    class="img-fluid"
                    src="assets/img/project-3.jpg"
                    alt=""
                  />
                  <div class="portfolio-btn">
                    <a
                      class="btn btn-lg-square btn-outline-secondary border-2 mx-1"
                      href="assets/img/project-3.jpg"
                      data-lightbox="portfolio"
                    >
                      <i class="fa fa-eye"></i>
                    </a>
                    <a
                      class="btn btn-lg-square btn-outline-secondary border-2 mx-1"
                      href=""
                    >
                      <i class="fa fa-link"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 portfolio-item second">
                <div class="portfolio-img rounded overflow-hidden">
                  <img
                    class="img-fluid"
                    src="assets/img/project-4.jpg"
                    alt=""
                  />
                  <div class="portfolio-btn">
                    <a
                      class="btn btn-lg-square btn-outline-secondary border-2 mx-1"
                      href="assets/img/project-4.jpg"
                      data-lightbox="portfolio"
                    >
                      <i class="fa fa-eye"></i>
                    </a>
                    <a
                      class="btn btn-lg-square btn-outline-secondary border-2 mx-1"
                      href=""
                    >
                      <i class="fa fa-link"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 portfolio-item first">
                <div class="portfolio-img rounded overflow-hidden">
                  <img
                    class="img-fluid"
                    src="assets/img/project-5.jpg"
                    alt=""
                  />
                  <div class="portfolio-btn">
                    <a
                      class="btn btn-lg-square btn-outline-secondary border-2 mx-1"
                      href="assets/img/project-5.jpg"
                      data-lightbox="portfolio"
                    >
                      <i class="fa fa-eye"></i>
                    </a>
                    <a
                      class="btn btn-lg-square btn-outline-secondary border-2 mx-1"
                      href=""
                    >
                      <i class="fa fa-link"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 portfolio-item second">
                <div class="portfolio-img rounded overflow-hidden">
                  <img
                    class="img-fluid"
                    src="assets/img/project-6.jpg"
                    alt=""
                  />
                  <div class="portfolio-btn">
                    <a
                      class="btn btn-lg-square btn-outline-secondary border-2 mx-1"
                      href="assets/img/project-6.jpg"
                      data-lightbox="portfolio"
                    >
                      <i class="fa fa-eye"></i>
                    </a>
                    <a
                      class="btn btn-lg-square btn-outline-secondary border-2 mx-1"
                      href=""
                    >
                      <i class="fa fa-link"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="container-xxl py-6 pb-5" id="team">
          <div class="container">
            <div class="row g-5 mb-5 wow fadeInUp" data-wow-delay="0.1s">
              <div class="col-lg-6">
                <h1 class="display-5 mb-0">Team Members</h1>
              </div>
              <div class="col-lg-6 text-lg-end">
                <a class="btn btn-primary py-3 px-5" href="">
                  Contact Us
                </a>
              </div>
            </div>
            <div class="row g-4">
              <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                <div class="team-item position-relative">
                  <img
                    class="img-fluid rounded"
                    src="assets/img/team-1.jpg"
                    alt=""
                  />
                  <div class="team-text bg-white rounded-end p-4">
                    <div>
                      <h5>Eric Amoah</h5>
                      <span>Designer</span>
                    </div>
                    <i class="fa fa-arrow-right fa-2x text-primary"></i>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                <div class="team-item position-relative">
                  <img
                    class="img-fluid rounded"
                    src="assets/img/team-2.jpg"
                    alt=""
                  />
                  <div class="team-text bg-white rounded-end p-4">
                    <div>
                      <h5>Homie</h5>
                      <span>Designer</span>
                    </div>
                    <i class="fa fa-arrow-right fa-2x text-primary"></i>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                <div class="team-item position-relative">
                  <img
                    class="img-fluid rounded"
                    src="assets/img/team-3.jpg"
                    alt=""
                  />
                  <div class="team-text bg-white rounded-end p-4">
                    <div>
                      <h5>Samuel Amoah</h5>
                      <span>Designer</span>
                    </div>
                    <i class="fa fa-arrow-right fa-2x text-primary"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="container-fluid bg-light py-5 my-5" id="testimonial">
          <div class="container-fluid py-5">
            <h1
              class="display-5 text-center mb-5 wow fadeInUp"
              data-wow-delay="0.1s"
            >
              Testimonial
            </h1>
            <div class="row justify-content-center">
              <div class="col-lg-3 d-none d-lg-block">
                <div class="testimonial-left h-100">
                  <img
                    class="img-fluid wow fadeIn"
                    data-wow-delay="0.1s"
                    src="assets/img/testimonial-1.jpg"
                    alt=""
                  />
                  <img
                    class="img-fluid wow fadeIn"
                    data-wow-delay="0.3s"
                    src="assets/img/testimonial-2.jpg"
                    alt=""
                  />
                  <img
                    class="img-fluid wow fadeIn"
                    data-wow-delay="0.5s"
                    src="assets/img/testimonial-3.jpg"
                    alt=""
                  />
                </div>
              </div>
              <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
                <div class="owl-carousel testimonial-carousel">
                  <div class="testimonial-item text-center">
                    <div class="position-relative mb-5">
                      <img
                        class="img-fluid rounded-circle border border-secondary p-2 mx-auto"
                        src="assets/img/testimonial-1.jpg"
                        alt=""
                      />
                      <div class="testimonial-icon">
                        <i class="fa fa-quote-left text-primary"></i>
                      </div>
                    </div>
                    <p class="fs-5 fst-italic">
                      “Loved to work with Samuel, he's such an awesome developer
                      with great attention to details. He also has a great eye
                      for design”
                    </p>
                    <hr class="w-25 mx-auto" />
                    <h5>Samantha Bloom</h5>
                    <span>Team Leader - Syncnow</span>
                  </div>
                  <div class="testimonial-item text-center">
                    <div class="position-relative mb-5">
                      <img
                        class="img-fluid rounded-circle border border-secondary p-2 mx-auto"
                        src="assets/img/testimonial-2.jpg"
                        alt=""
                      />
                      <div class="testimonial-icon">
                        <i class="fa fa-quote-left text-primary"></i>
                      </div>
                    </div>
                    <p class="fs-5 fst-italic">
                      “So glad we started working with Samuel. We've used many
                      times his design and development skills for our inhouse
                      online projects”
                    </p>
                    <hr class="w-25 mx-auto" />
                    <h5>John Rowling</h5>
                    <span>Marketing Manager - Nexlite</span>
                  </div>
                  <div class="testimonial-item text-center">
                    <div class="position-relative mb-5">
                      <img
                        class="img-fluid rounded-circle border border-secondary p-2 mx-auto"
                        src="assets/img/testimonial-3.jpg"
                        alt=""
                      />
                      <div class="testimonial-icon">
                        <i class="fa fa-quote-left text-primary"></i>
                      </div>
                    </div>
                    <p class="fs-5 fst-italic">
                      “Samuel is a skilled developer which will do everything
                      possible to deliver the project on time and I really
                      appreciate that”
                    </p>
                    <hr class="w-25 mx-auto" />
                    <h5>Philip Amoah</h5>
                    <span>Doctor - AidLife</span>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 d-none d-lg-block">
                <div class="testimonial-right h-100">
                  <img
                    class="img-fluid wow fadeIn"
                    data-wow-delay="0.1s"
                    src="assets/img/testimonial-1.jpg"
                    alt=""
                  />
                  <img
                    class="img-fluid wow fadeIn"
                    data-wow-delay="0.3s"
                    src="assets/img/testimonial-2.jpg"
                    alt=""
                  />
                  <img
                    class="img-fluid wow fadeIn"
                    data-wow-delay="0.5s"
                    src="assets/img/testimonial-3.jpg"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="container-xxl pb-5" id="contact">
          <div class="container py-5">
            <div class="row g-5 mb-5 wow fadeInUp" data-wow-delay="0.1s">
              <div class="col-lg-6">
                <h1 class="display-5 mb-0">Let's Work Together</h1>
              </div>
              <div class="col-lg-6 text-lg-end">
                <a class="btn btn-primary py-3 px-5" href="">
                  Say Hello
                </a>
              </div>
            </div>
            <div class="row g-5">
              <div class="col-lg-5 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                <p class="mb-2">My office:</p>
                <h3 class="fw-bold">Atonsu, Ashanti Region, GHANA</h3>
                <hr class="w-100" />
                <p class="mb-2">Call me:</p>
                <h3 class="fw-bold">+233-599-615860</h3>
                <hr class="w-100" />
                <p class="mb-2">Mail me:</p>
                <h3 class="fw-bold">samuellove226.com</h3>
                <hr class="w-100" />
                <p class="mb-2">Follow me:</p>
                <div class="d-flex pt-2">
                  <a
                    class="btn btn-square btn-primary me-2"
                    href="https://twitter.com/samuellove226"
                  >
                    <i class="fab fa-twitter"></i>
                  </a>
                  <a
                    class="btn btn-square btn-primary me-2"
                    href="https://web.facebook.com/adobe.rich.9"
                  >
                    <i class="fab fa-facebook-f"></i>
                  </a>
                  <a
                    class="btn btn-square btn-primary me-2"
                    href="https://wa.me/qr/KEJ6B3WFUW4IK1"
                  >
                    <i class="fab fa-whatsapp"></i>
                  </a>
                  <a
                    class="btn btn-square btn-primary me-2"
                    href="https://homies-qze3220.slack.com/"
                  >
                    <i class="fab fa-slack"></i>
                  </a>
                </div>
              </div>
              <div class="col-lg-7 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                <p class="mb-4">
                  For any type of online project please don't hesitate to get in
                  touch with me. The fastest way is to send me your message
                  using the following email{" "}
                  <a href="mailto:samuellove226@gmail.com">HERE</a>.
                </p>
                <form>
                  <div class="row g-3">
                    <div class="col-md-6">
                      <div class="form-floating">
                        <input
                          type="text"
                          class="form-control"
                          id="name"
                          placeholder="Your Name"
                        />
                        <label for="name">Your Full Name</label>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-floating">
                        <input
                          type="email"
                          class="form-control"
                          id="email"
                          placeholder="Your Email"
                        />
                        <label for="email">Your Email</label>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-floating">
                        <input
                          type="text"
                          class="form-control"
                          id="subject"
                          placeholder="Subject"
                        />
                        <label for="subject">Subject</label>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-floating">
                        <textarea
                          class="form-control"
                          placeholder="Leave a message here"
                          id="message"
                          style={{ height: "100px" }}
                        ></textarea>
                        <label for="message">Message</label>
                      </div>
                    </div>
                    <div class="col-12">
                      <button class="btn btn-primary py-3 px-5" type="submit">
                        Send Message
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div class="container-xxl pt-5 px-0 wow fadeInUp" data-wow-delay="0.1s">
          <div class="container-xxl pt-5 px-0">
            <div class="bg-dark">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31704.002306931256!2d-1.6254724370482347!3d6.646883792394904!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xfdb915ca4637251%3A0x259b67ea02a72392!2sAtonsu%2C%20Kumasi!5e0!3m2!1sen!2sgh!4v1656249582224!5m2!1sen!2sgh" width="100%" height="450" style={{border:"0"}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
          </div>
        </div>

        <div class="container-fluid bg-dark text-white py-4">
          <div class="container">
            <div class="row">
              <div class="col-md-6 text-center text-md-start mb-3 mb-md-0">
                &copy;{" "}
                <a class="border-bottom text-secondary" href="#">
                  Homie portfolio
                </a>
                , All Right Reserved.
              </div>
              <div class="col-md-6 text-center text-md-end">
                Designed By{" "}
                <a
                  class="border-bottom text-secondary"
                  href="https://htmlcodex.com"
                >
                  HOMIE
                </a>
                <br />
                Distributed By:{" "}
                <a class="border-bottom" href="https://GOOGLE.com">
                  Google
                </a>
              </div>
            </div>
          </div>
        </div>

        <a href="#" class="btn btn-lg btn-primary btn-lg-square back-to-top">
          <i class="bi bi-arrow-up"></i>
        </a>
        <script>
        <script src="https://code.jquery.com/jquery-3.4.1.min.js"></script>
        <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.0.0/dist/js/bootstrap.bundle.min.js"></script>
        <script src="./assets/lib/wow/wow.min.js"></script>
        <script src="./assets/lib/easing/easing.min.js"></script>
        <script src="./assets/lib/waypoints/waypoints.min.js"></script>
        <script src="./assets/lib/typed/typed.min.js"></script>
        <script src="./assets/lib/counterup/counterup.min.js"></script>
        <script src="./assets/lib/owlcarousel/owl.carousel.min.js"></script>
        <script src="./assets/lib/isotope/isotope.pkgd.min.js"></script>
        <script src="./assets/lib/lightbox/js/lightbox.min.js"></script>


        <script src="./assets/js/main.js"></script>
        </script>
      </div>
      
      
    );
  }
}

export default home;
